<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <!-- 공사 계약승인 상세 팝업 -->
    <!-- <contract-approval-manage-detail-pop-up
      :popupVisible="popupVisible"
      @popupClose="popupClose"
      title="공사 계약승인"
      :constructData="constructData"
      :companyData="companyData"
      :fileData="fileData"
    />-->
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="공사 계약승인" :IsUseEditorBox="true" device="web">
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="startDate"
                placeholder="시작일자"
                :menu="true"
                :dateOnly="true"
                @getDate="setSearchDate($event, 'start')"
              ></i-date-time-picker>
              <!-- :allowMaxDate="minDate" -->
            </v-col>
            <span class="pt-1 mx-1">~</span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="endDate"
                placeholder="종료일자"
                :menu="true"
                :dateOnly="true"
                @getDate="setSearchDate($event, 'end')"
              ></i-date-time-picker>
              <!-- :allowMinDate="minDate" -->
            </v-col>
          </v-row>
        </template>
        <template v-slot:body>
          <DxDataGrid
            id="contractApprovalManageDataGrid"
            class="layout-col-height00"
            style="width: 100%; height: 100%"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :focused-row-enabled="true"
            :selection="{ mode: 'single' }"
            key-expr="uniqueKey"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />
            <DxColumn data-field="clntId" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="compId" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="writeDt" data-type="string" :visible="false"></DxColumn>
            <DxColumn data-field="docNo" data-type="string" :visible="false"></DxColumn>

            <DxColumn
              data-field="save"
              data-type="string"
              width="100px"
              alignment="center"
              caption
              :allow-editing="false"
              cell-template="actionTemplete"
            ></DxColumn>
            <template #actionTemplete="{ data: cellInfo }">
              <v-btn color="primary" small elevation="0" @click="btnDetail(cellInfo)" class="grid-btn">상세보기</v-btn>
            </template>
            <DxColumn data-field="bizManageNm" data-type="string" alignment="center" width="150px" caption="관리 사업소" :allow-editing="false" />
            <DxColumn data-field="bizManagerNm" data-type="string" alignment="center" width="100px" caption="담당자명" :allow-editing="false" />
            <DxColumn data-field="clntNm" data-type="string" alignment="left" width="200px" caption="고객사명" :allow-editing="false" />

            <DxColumn data-field="constructNm" data-type="string" alignment="left" width="300px" caption="사업장(공사)명" :allow-editing="false" />
            <DxColumn
              data-field="approvalStatus"
              data-type="string"
              width="150px"
              alignment="center"
              caption="사업장(공사) 승인"
              cell-template="approvalStatusTemplate"
              :allow-editing="false"
            ></DxColumn>
            <template #approvalStatusTemplate="{ data: cellInfo }">
              <div :style="getStatusStyle('approvalList', cellInfo.data.approvalStatus)">
                {{ getStatusNm('approvalList', cellInfo.data.approvalStatus) }}
              </div>
            </template>
            <DxColumn
              data-field="paymentStatus"
              data-type="string"
              alignment="left"
              caption="결제 승인"
              width="200px"
              :allow-editing="false"
              cell-template="paymentApprovalTemplate"
            />
            <template #paymentApprovalTemplate="{ data: cellInfo }">
              <div class="d-flex justify-start">
                <div :style="getStatusStyle('paymentList', cellInfo.data.paymentStatus)">
                  {{ getStatusNm('paymentList', cellInfo.data.paymentStatus) }}
                </div>
                <div
                  v-if="cellInfo.data.orderType && (cellInfo.data.paymentStatus === 'N' || cellInfo.data.paymentStatus === 'A')"
                  style="color: #b4b4b4"
                >
                  {{ `/${cellInfo.data.orderType === 'AC' ? '직접계좌이체' : '카드(신용)'}` }}
                  {{ `${cellInfo.data.paymentType === 'BILLING' ? '/월 구독' : ''}` }}
                </div>
              </div>
            </template>

            <DxColumn data-field="constructTerm" data-type="string" alignment="center" caption="공사 기간" width="250px" :allow-editing="false" />

            <DxColumn data-field="constructAmount" data-type="string" alignment="right" caption="공사비용(원)" width="170px" :allow-editing="false" />

            <!-- <DxColumn
              data-field="approvalStatus"
              data-type="string"
              width="120px"
              alignment="center"
              caption="승인 상태"
              cell-template="approvalStatusTemplate"
              :allow-editing="false"
            ></DxColumn>
            <template #approvalStatusTemplate="{ data: cellInfo }">
              <div style="color:blue;" v-if="cellInfo.data.approvalStatus == 'A'">승인</div>
              <div style="color:red;" v-else-if="cellInfo.data.approvalStatus == 'R'">거절</div>
              <div style="color:grey;"v-else>승인 대기</div>
            </template>-->

            <DxColumn data-field="writeDate" data-type="string" alignment="center" caption="최초 작성일" width="120px" :allow-editing="false" />

            <DxColumn data-field="contractDt" data-type="string" alignment="center" caption="계약승인" width="200px" :allow-editing="false" />
            <DxColumn data-field="feeName" data-type="string" alignment="center" caption="요금제" width="200px" :allow-editing="false" />
            <DxColumn data-field="feeAmount" data-type="string" alignment="right" caption="요금(원)" width="200px" :allow-editing="false" />

            <DxColumn data-field="adminComment" data-type="string" alignment="left" width="150px" caption="코멘트" :allow-editing="false" />
          </DxDataGrid>
        </template>
      </i-card-vertical>
      <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)">
        <template v-slot:body>
          <v-layout>
            <v-row no-gutters class="pa-0 pt-2">
              <v-col cols="12" md="4"></v-col>
            </v-row>
          </v-layout>
        </template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>
<script>
import {
  getContractApprovalManage,
  getContractApprovalManageDetail,
  saveContractApprovalManage,
  saveContractApprovalStatus,
} from '@/api/adminManagement/contractApprovalManage'
import { getCompManageDetail } from '@/api/sojunganManagement/compMange'
import { getCommonCode } from '@/api/common/commonApi'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { getCurrentDate, getPreMonth } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'
export default {
  mixins: [baseview, BaseDataGrid],
  name: 'contractApprovalManageDataGrid',
  components: {
    IDateTimePicker,
  },
  data() {
    return {
      dxDataGridRef: 'contractApprovalManageDataGrid',
      buttonUseList: [
        'btnSearch', // 조회
      ],
      gridMain: [],
      startDate: getPreMonth(12),
      endDate: getPreMonth(-1),
      searchStartDate: getPreMonth(12).replace(/[^0-9]/g, ''),
      searchEndDate: getPreMonth(-1).replace(/[^0-9]/g, ''),
      searchMinDate: getCurrentDate(),
      searchMaxDate: getPreMonth(12),
      minDate: getCurrentDate(),
      // 팝업 관련
      popupVisible: false,
      popupHeight: '',
      popupWidth: '',
      popupMinWidth: '',
      popupTitle: '',
      constructData: {},
      companyData: {},
      fileData: {
        logo: null,
        logoFile: null,
        logoFileNm: null,
        logo__fileUpdate__: false,
        seal: null,
        sealFile: null,
        sealFileNm: null,
        seal__fileUpdate__: false,
      },
      approvalList: [],
      paymentList: [],
      cancelList: [],
    }
  },
  computed: {},
  created() {
    // 승인 / 결제 / 해지 단계 공통코드 조회
    Promise.all([getCommonCode('CM014'), getCommonCode('CM017'), getCommonCode('CM018')]).then((res) => {
      ;(this.approvalList = res[0].list), (this.paymentList = res[1].list), (this.cancelList = res[2].list)
    })
  },
  beforeMount() {},
  activated() {
    // 일반 메뉴로 들어올 경우 기존 조회 기간인 12개월 전~다음달까지 적용
    this.applySearchPeriod(12, -1)

    if (this.$route.params.data) {
      let params = this.$route.params.data
      if (params.flag) {
        this.btnSearch(true)
      }
    }
  },
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    // 대시보드에서 넘어올 경우 최근 2개월을 조회 기간으로 설정
    applySearchPeriod(defaultStartMonths, defaultEndMonths = 0) {
      const query = this.$route.query || {}
      const fromDashboard =
        query.from === 'dashboard' && query.period === '2months'

      const startDate = getPreMonth(
        fromDashboard ? 2 : defaultStartMonths
      )
      const endDate = fromDashboard
        ? getCurrentDate()
        : getPreMonth(defaultEndMonths)

      // 날짜 선택기에 표시할 값
      this.startDate = startDate
      this.endDate = endDate

      // API 조회에 사용할 값
      this.searchStartDate = startDate.replace(/[^0-9]/g, '')
      this.searchEndDate = endDate.replace(/[^0-9]/g, '')

      this.btnSearch(true)
    },
    getStatusStyle(dataList, status) {
      // 진행상태에 따라 스타일 부여
      let style = ''
      let statusCd = this[dataList].find((el) => el.minorCd === status)
      if (statusCd) {
        switch (statusCd.minorCd) {
          case 'W':
            style = `color:#B4B4B4;`
            break
          case 'N':
            style = `color:#B4B4B4;`
            break
          case 'R':
            style = `color:#FF2D2D;`
            break
          case 'S':
            style = `color:#CC6600;`
            break
          case 'A':
            style = `color:#1B53F3;`
            break
        }
      }
      return style
    },
    getStatusNm(dataList, status) {
      let statusCd = this[dataList].find((el) => el.minorCd === status)
      if (statusCd) return statusCd.minorNm
      else return '-'
    },
    //------------------------------------------
    //  검색 년월일 포맷
    //------------------------------------------
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchMinDate = e
        this.searchStartDate = e.replace(/[^0-9]/g, '')
      } else if (div === 'end') {
        this.searchMaxDate = e
        this.searchEndDate = e.replace(/[^0-9]/g, '')
      }
    },
    //------------------------------------------
    //  공사 계약승인 조회
    //------------------------------------------
    async btnSearch(isNotify) {
      this.openLoading()

      let params = {
        searchStartDate: this.searchStartDate,
        searchEndDate: this.searchEndDate,
      }
      try {
        const response = await getContractApprovalManage(params, isNotify)

        if (response.success) {
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          this.gridMain = []
          this.gridMain = response.list
          this.gridMain = response.list.map((item) => {
            item.uniqueKey = `${item.clntId}${item.compId}${item.writeDt}${item.docNo}`
            item.constructTerm = `${item.constructDtS.slice(0, 4)}.${item.constructDtS.slice(4, 6)}.${item.constructDtS.slice(
              6,
              8
            )} ~ ${item.constructDtE.slice(0, 4)}.${item.constructDtE.slice(4, 6)}.${item.constructDtE.slice(6, 8)}`
            if (item.contractDt !== null) {
              item.contractDt = `계약일(${item.contractDt.slice(0, 4)}.${item.contractDt.slice(4, 6)}.${item.contractDt.slice(6, 8)})`
            }
            item.constructAmount = item.constructAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            if (item.feeAmount != null) {
              item.feeAmount = item.feeAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            item.writeDate = `${item.writeDt.substring(0, 4)}.${item.writeDt.substring(4, 6)}.${item.writeDt.substring(6, 8)}`
            return item
          })
          this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
        }
      } catch (error) {
        console.error('getContractApprovalManage error catch >> ', error)
      } finally {
        this.endLoading()
      }
    },
    //------------------------------------------
    //  공사 계약승인 저장
    //------------------------------------------
    async btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then((selectedRows) => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }

          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            async () => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              for (const item of selectedRows) {
                if (item.adminComment == '') {
                  item.adminComment = null
                }
              }

              this.openLoading('saving')
              try {
                await saveContractApprovalManage(selectedRows, true)
                this.btnSearch(false)
              } catch (error) {
                console.error('saveContractApprovalManage error catch >> ', error)
              } finally {
                this.GetDataGrid(this.dxDataGridRef).endUpdate()
                this.endLoading()
              }
            },
            null,
            true
          )
        })
    },
    //------------------------------------------
    //  공사 계약승인 상세페이지 팝업 실행
    //------------------------------------------
    async btnDetail(cellInfo) {
      let params = {
        clntId: cellInfo.data.clntId,
        compId: cellInfo.data.compId,
        writeDt: cellInfo.data.writeDt,
        docNo: cellInfo.data.docNo,
        flag: true,
      }
      const toRouter = {
        name: 'ContractApprovalManageDetail',
        params: {
          data: params,
        },
      }
      this.$router.push(toRouter)
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    onEditingStart(e) {},
    //------------------------------------------
    //  날짜 포맷
    //------------------------------------------
    formatDate(date) {
      const year = date.substring(0, 4)
      const month = date.substring(4, 6)
      const day = date.substring(6, 8)
      return `${year}-${month}-${day}`
    },
  },
}
</script>

<style scoped></style>
